import qs from "qs";
import axios from "axios";

import {IContainerDetailsData, IShipmentDetailsData} from "./Shipment.ShipmentDetails.types";

export default class ShipmentDetailsApi {

    static async getShipmentDetailsData({queryKey}: any) {
        let [_, referenceNumber] = queryKey;
        try {
            let res = await axios.get(`/Shipments/${referenceNumber}`);
            return res.data as IShipmentDetailsData;
        } catch (e: any) {
            console.error('Could not get Shipment Details data: ', e.message);
            return undefined;
        }
    }

    static async getContainersByShipmentId({queryKey}: any) {
        const [_, referenceNumber] = queryKey;
        try {
            let res = await axios.get(`/Shipments/${referenceNumber}/Containers`);
            return res.data as IContainerDetailsData[];
        } catch (e: any) {
            console.error('Could not get Container Details data: ', e.message);
            return undefined;
        }
    }

    static async getContainerDetailsData({queryKey}: any) {
        let containerNumber = queryKey[1].containerNumber;
        try {
            let res = await axios.get(`/Shipments/${containerNumber}/ContainerDetails`);
            return res.data as IContainerDetailsData;
        } catch (e: any) {
            console.error('Could not get Container Details data: ', e.message);
            return undefined;
        }
    }
}